export var GlobalVariables = (function () {
  // Variables
  var myURL = process.env.REACT_APP_AZURE_URL;
  var DEFAULT_COLUMN_WIDTH = 200;

  // Methods
  return {
    getURL: function () {
      return myURL;
    },
    setURL: function (newURL) {
      myURL = newURL;
    },
    getDefaultColumnWidth: () => {
      return DEFAULT_COLUMN_WIDTH;
    },
  };
})();
